import { initMobileMenu } from './utils/mobile-menu.mjs';

const menu = document.getElementById('mobile-menu');
const triggers = document.querySelectorAll('[aria-controls="mobile-menu"]');
initMobileMenu(menu, triggers);
